export const revokeBlobUrls = (urls: string[]) => {
  for (const url of urls) {
    URL.revokeObjectURL(url);
  }
};
